import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { Forklift, Menu, X } from "lucide-react";

export default function Header() {
  const { t, toggleLanguage, lang } = useLanguage();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = React.useState(false);

  const isAdmin = location.pathname.startsWith("/admin");
  if (isAdmin) return null;

  const navLinks = [
    { to: "/", label: t.nav.home },
    { to: "/inventory", label: t.nav.inventory },
    { to: "/request", label: t.nav.request },
    { to: "/check-request", label: lang === "en" ? "Check Request" : "Vérifier demande" },
  ];

  return (
    <header
      data-testid="main-header"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/95 border-b border-gray-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo-link">
          <div className="w-9 h-9 bg-yellow-400 rounded-sm flex items-center justify-center">
            <Forklift className="w-5 h-5 text-gray-900" />
          </div>
          <div className="leading-tight">
            <span className="font-heading text-xl font-bold text-gray-900 tracking-tight block">
              Fork Finder
            </span>
            <span className="text-[10px] text-gray-400 tracking-wide">
              by Gesti&oacute;n Farcar
            </span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              data-testid={`nav-link-${link.to.replace("/", "") || "home"}`}
              className={`text-sm font-medium transition-colors ${
                location.pathname === link.to
                  ? "text-gray-900"
                  : "text-gray-500 hover:text-gray-900"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="language-toggle"
            onClick={toggleLanguage}
            className="text-xs uppercase tracking-widest font-bold px-3 py-1 border border-gray-200 hover:bg-gray-100 rounded-sm transition-colors"
          >
            {t.nav.language}
          </button>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden p-2 text-gray-600"
          >
            {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-gray-200 bg-white px-6 py-4 space-y-3" data-testid="mobile-menu">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setMenuOpen(false)}
              className="block text-sm font-medium text-gray-700 hover:text-gray-900"
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
